var render, staticRenderFns
import script from "./gaode_district_type.vue?vue&type=script&lang=js"
export * from "./gaode_district_type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14ae5aef')) {
      api.createRecord('14ae5aef', component.options)
    } else {
      api.reload('14ae5aef', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/gaode_district_type/gaode_district_type.vue"
export default component.exports